import { Warning, Info, CheckCircle, Lightning } from '@phosphor-icons/react';
import { formatDate } from '@/lib/utils';

const severityConfig = {
  high: { icon: Warning, color: 'text-[#DC2626]', bg: 'bg-[#FEF2F2]', border: 'border-l-[#DC2626]' },
  medium: { icon: Info, color: 'text-amber-600', bg: 'bg-amber-50', border: 'border-l-amber-600' },
  low: { icon: CheckCircle, color: 'text-green-600', bg: 'bg-green-50', border: 'border-l-green-600' },
};

export default function AlertCard({ alert }) {
  const config = severityConfig[alert.severity] || severityConfig.medium;
  const Icon = config.icon;
  
  return (
    <div 
      className={`alert-card ${alert.severity} relative`}
      data-testid={`alert-card-${alert.type}`}
    >
      <div className="flex items-start gap-3">
        <div className={`p-1.5 rounded-md ${config.bg}`}>
          <Icon size={16} className={config.color} weight="fill" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <h4 className="text-sm font-medium text-[#0F172A] font-['Plus_Jakarta_Sans']">{alert.title}</h4>
            {alert.type === 'ai' && (
              <span className="inline-flex items-center gap-1 text-[10px] bg-[#0F4C81] text-white px-1.5 py-0.5 rounded">
                <Lightning size={10} weight="fill" />
                AI
              </span>
            )}
          </div>
          <p className="text-xs text-[#64748B] mt-1 line-clamp-2">{alert.message}</p>
          <p className="text-[10px] text-[#64748B] mt-2">{formatDate(alert.date)}</p>
        </div>
      </div>
    </div>
  );
}
